<script>
    const axios = require('axios');

    export default {
        props: {
            'api': {
                type: String,
                default: '/trainings/search/autocomplete'
            },
        },

        data() {
            return {
                trainings: [],
                blogPosts: [],
                query: '',
                selectedTraining: -1,
            }
        },

        watch: {
            query: function (newQuery, oldQuery) {
                this.search();
            }
        },

        methods: {
            submit() {
                if (this.selectedTraining >= 0) {
                    window.location.href = "/" + this.trainings[this.selectedTraining].slug;
                    return;
                }

                window.location.href = "/online-kurse/?q=" + this.query;
            },

            up() {
                this.selectedTraining--;

                if (this.selectedTraining < 0) {
                    this.selectedTraining = this.trainings.length - 1;
                }
            },

            down() {
                this.selectedTraining++;

                if (this.selectedTraining > this.trainings.length) {
                    this.selectedTraining = 0;
                }
            },

            search() {
                if(this.query.length < 2) {
                    this.trainings = [];
                    this.blogPosts = [];
                    return;
                }

                axios.post(this.api, {
                    q: this.query
                })
                .then(response => {
                    this.trainings = response.data.data;
                    this.blogPosts = response.data.posts;
                });
            }

        },
    };
</script>